import React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import { InsuranceForm } from './InsuranceForm';

export const InsuranceEdit = () => (
  <Edit>
    <SimpleForm>
      <InsuranceForm />
    </SimpleForm>
  </Edit>
);
